<template>
  <div v-loading.body="loading">
    <el-menu
      :default-active="$route.path"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#409EFF"
      router
    >
      <el-menu-item index="/home/wavepicking/wavepickinglist"
        >波次单列表</el-menu-item
      >
      <el-menu-item index="/home/aswavepicking/aswavepickinglist"
        >售后波次</el-menu-item
      >
      <el-menu-item index="/home/wavepicking/TempSummaryList/5"
        >质检汇总</el-menu-item
      >
      <el-menu-item index="/home/wavepicking/TempSummaryList/6"
        >改标汇总</el-menu-item
      >
      <el-menu-item index="/home/surpassSummary/surpassSummaryPickingList"
        >中分汇总拣货</el-menu-item
      >
    </el-menu>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item>
                    <el-select
                      v-model="search_type"
                      placeholder="波次号"
                      style="width: 120px"
                      @change="search_type_change"
                    >
                      <el-option
                        v-for="item in search_options"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="margin-left: -15px">
                    <el-input
                      v-model="search_value"
                      placeholder="请输入搜索内容"
                      style="width: 195px"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.status"
                      placeholder="请选择状态"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in conditionData.status"
                        :key="item.status_id"
                        :label="item.status_name"
                        :value="item.status_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.type"
                      placeholder="请选择波次类型"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in conditionData.type"
                        :key="item.type_id"
                        :label="item.type_name"
                        :value="item.type_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.picking_type"
                      placeholder="波次拣货属性"
                      style="width: 150px"
                      multiple
                    >
                      <el-option value="0" label="全部"></el-option>
                      <el-option
                        v-for="item in conditionData.picking_type"
                        :key="item.type_id"
                        :label="item.type_name"
                        :value="item.type_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_generate_picking_task"
                      placeholder="是否生成拣货任务"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in conditionData.generate_picking_task"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="波次时间：">
                    <el-date-picker
                      v-model="form.create_time"
                      :default-time="['06:00:00', '06:00:00']"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="width: 350px"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.print_status"
                      placeholder="面单状态"
                    >
                      <el-option label="全部" value="0"></el-option>
                      <el-option
                        v-for="item in conditionData.print_status"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="是否优质用户订单">
                    <el-select
                      v-model="form.is_prior"
                      placeholder="是否优质用户订单"
                    >
                      <el-option label="全部" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      style="background-color: #e1e1e1"
                      @click="resetCondition"
                      >重置</el-button
                    >
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="search">
                      查询波次
                    </el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="dialogFormUserVisible = true"
                      >按用户ID筛选波次（数量：{{
                        userSearchCount
                      }}）</el-button
                    >
                  </el-form-item>
                  <el-dialog
                    v-loading="loading"
                    :title="`当前录入用户ID数量：${userSearchCount}（多个用户ID以换行方式隔开，单次最多1000个）`"
                    :visible.sync="dialogFormUserVisible"
                  >
                    <el-form :model="form">
                      <el-form-item>
                        <el-input
                          v-model="form.user_search"
                          type="textarea"
                          :autosize="{ minRows: 5, maxRows: 10 }"
                          placeholder="请输入内容"
                        ></el-input>
                      </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="userSearchCancel">取 消</el-button>
                      <el-button
                        type="primary"
                        @click="dialogFormUserVisible = false"
                        >确 定</el-button
                      >
                    </div>
                  </el-dialog>
                  <el-form-item>
                    <el-button type="success" @click="show_statistics = true">
                      统计数据查看
                    </el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="is_show_search_option = !is_show_search_option"
                    >
                      <i class="el-icon-arrow-down" />
                    </el-button>
                  </el-form-item>
                  <div v-if="is_show_search_option">
                    <el-form-item>
                      <el-select
                        v-model="form.full_allot"
                        placeholder="配齐状态"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in is_pq"
                          :key="item.key"
                          :label="item.name"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.pay"
                        placeholder="支付方式"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in payData"
                          :key="item.pay_id"
                          :label="item.pay_name"
                          :value="item.pay_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item>
                      <el-select
                        v-model="form.is_remark"
                        multiple
                        placeholder="请选择有无备注"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in noteWithoutNumData"
                          :key="item.note_id"
                          :label="item.note_name"
                          :value="item.note_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="
                        (form.is_remark || []).some((item) =>
                          [1, 2].includes(item)
                        )
                      "
                    >
                      <el-select
                        v-model="form.note_type"
                        placeholder="备注类型"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in noteData"
                          :key="item.note_id"
                          :label="item.note_name"
                          :value="item.note_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.shipping_company"
                        placeholder="选择快递公司"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in conditionData.express"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <!--<el-form-item>-->
                    <!--<el-select v-model="form.sender_type" placeholder="寄件人信息" style="width: 150px">-->
                    <!--<el-option :label="item.name" :value="item.key" v-for="item in sender_type" :key="item.key"></el-option>-->
                    <!--</el-select>-->
                    <!--</el-form-item>-->

                    <el-form-item>
                      <el-select
                        v-model="form.is_stock"
                        placeholder="是否囤货"
                        style="width: 150px"
                      >
                        <el-option value="">全部</el-option>
                        <el-option
                          v-for="item in conditionData.is_stock"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item>
                      <el-select
                        v-model="form.is_stop_shipping"
                        placeholder="是否拦截"
                        style="width: 150px"
                      >
                        <el-option value="">全部</el-option>
                        <el-option
                          v-for="item in conditionData.is_stop_shipping"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="波次待发数量">
                      <el-input
                        v-model="form.wave_picking_num"
                        placeholder="波次待发数量"
                        style="width: 150px"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="~">
                      <el-input
                        v-model="form.wave_picking_num_end"
                        placeholder="波次待发数量"
                        style="width: 150px"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="订单时间：">
                      <el-date-picker
                        v-model="form.order_time"
                        :default-time="['06:00:00', '06:00:00']"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width: 350px"
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.province"
                        multiple
                        filterable
                        placeholder="省"
                        style="width: 150px"
                        @change="getCity"
                      >
                        <el-option
                          v-for="item in conditionData.province"
                          :key="item.region_id"
                          :label="item.region_name"
                          :value="item.region_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.city"
                        multiple
                        filterable
                        placeholder="市"
                        style="width: 150px"
                        @change="getDistrict"
                      >
                        <el-option
                          v-for="item in cityData.list"
                          :key="item.region_id"
                          :label="item.region_name"
                          :value="item.region_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.district"
                        multiple
                        filterable
                        placeholder="区"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in districtData.list"
                          :key="item.region_id"
                          :label="item.region_name"
                          :value="item.region_id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.market_id"
                        multiple
                        filterable
                        placeholder="除去市场"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in conditionData.market"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.cat_ids"
                        multiple
                        filterable
                        placeholder="商品一级分类"
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in conditionData.category"
                          :key="item.cat_id"
                          :label="item.cat_name"
                          :value="item.cat_id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.same_day_shipping"
                        placeholder="是否即日发"
                        style="width: 150px"
                      >
                        <el-option value="">全部</el-option>
                        <el-option
                          v-for="item in conditionData.same_day_shipping"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.has_spot_order"
                        placeholder="是否有现货订单"
                        style="width: 150px"
                      >
                        <el-option value="">全部</el-option>
                        <el-option
                          v-for="item in conditionData.has_spot_order"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="用户层级标签">
                      <el-cascader
                        v-model="twoType"
                        :options="conditionData.two_type"
                        :props="{ multiple: true }"
                        filterable
                        @change="changeTwoType"
                      >
                      </el-cascader>
                    </el-form-item>
                    <el-form-item label="用户净值标签">
                      <el-select
                        v-model="form.user_net_worth_type"
                        placeholder="请选择用户净值标签"
                        multiple
                      >
                        <el-option value="">全部</el-option>
                        <el-option
                          v-for="item in conditionData.user_net_worth_type"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="出库时间：">
                      <el-date-picker
                        v-model="form.out_time"
                        :default-time="['06:00:00', '06:00:00']"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width: 350px"
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.remark_type"
                        placeholder="仓库备注类型"
                        style="width: 150px"
                      >
                        <el-option value="" label="全部"></el-option>
                        <el-option value="1" label="快递分配失败"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-cascader
                        v-model="form.hgd_id"
                        placeholder="选择中分位"
                        :props="hgCodeByHgProps"
                      ></el-cascader>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.is_today_shipments"
                        placeholder="发货波次单筛选"
                        style="width: 150px"
                      >
                        <el-option value="0" label="全部"></el-option>
                        <el-option value="1" label="今日可发"></el-option>
                        <el-option value="2" label="次日可发"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-form>
              </el-col>
            </div>
            <div style="padding: 0 25px">
              <el-form
                v-if="resData"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item>
                  <el-dropdown
                    split-button
                    type="danger"
                    @click="lockWavePicking(0)"
                    @command="lockWavePicking"
                  >
                    锁定波次
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="1"
                        >全部锁定波次</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" @click="generateTaskBefore">
                    生成拣货任务
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-upload
                    style="margin: 0 10px 2px"
                    :action="action1"
                    name="excel"
                    :limit="1"
                    :on-success="importFileWeight"
                    :file-list="fileList"
                    auto-upload
                    with-credentials
                  >
                    <el-button type="primary">导入重量</el-button>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="dialogFormVisible = true">
                    导入快递单
                  </el-button>
                </el-form-item>
                <el-dialog
                  v-loading="loading"
                  title="请先选择快递公司"
                  :visible.sync="dialogFormVisible"
                >
                  <el-form :model="form">
                    <el-form-item label="快递公司">
                      <el-select
                        v-model="form.express"
                        placeholder="请选择快递公司"
                      >
                        <el-option
                          v-for="express in conditionData.express"
                          :key="express"
                          :label="express"
                          :value="express"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="导入快递单">
                      <el-upload
                        ref="upload"
                        :action="action2"
                        name="excel"
                        :limit="1"
                        :on-success="importFileExpress"
                        :file-list="fileList"
                        :auto-upload="true"
                        with-credentials
                      >
                        <el-button slot="trigger" size="mini" type="primary">
                          选择文件
                        </el-button>
                      </el-upload>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false"
                      >取 消</el-button
                    >
                    <!--<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>-->
                    <el-button type="primary" @click="importExpress">
                      确 定
                    </el-button>
                  </div>
                </el-dialog>
                <el-form-item>
                  <el-button type="success" @click="output">
                    导出波次单
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="outputInfo">
                    导出波次单明细
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="exportExpress">
                    导出电子面单
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="outputExpress">
                    物流数据导出
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="outputLog">
                    导出改排日志
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="success"
                    style="margin-left: -18px"
                    @click="show_log_time = !show_log_time"
                    ><i class="el-icon-date"
                  /></el-button>
                  <el-date-picker
                    v-if="show_log_time == 1"
                    v-model="form.log_time"
                    format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker> </el-form-item
                ><br />
                <el-form-item>
                  <el-button type="success" @click="outputLabel">
                    导出改标用户波次明细
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="success"
                    style="margin-left: -18px"
                    @click="show_label_time = !show_label_time"
                    ><i class="el-icon-date"
                  /></el-button>
                  <el-date-picker
                    v-if="show_label_time == 1"
                    v-model="form.label_time"
                    format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="outputReAllotLog">
                    改排重配明细导出
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="success"
                    style="margin-left: -18px"
                    @click="show_gp_time = !show_gp_time"
                    ><i class="el-icon-date"
                  /></el-button>
                  <el-date-picker
                    v-if="show_gp_time == 1"
                    v-model="form.gp_time"
                    format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="infor" @click="exlceImprot">
                    导入批量修改波次
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-upload
                    :action="action3"
                    name="excel"
                    :limit="1"
                    :on-success="importFileWeight"
                    :file-list="fileList"
                    auto-upload
                    with-credentials
                  >
                    <el-button type="primary">导入物流信息</el-button>
                  </el-upload>
                </el-form-item>

                <el-form-item>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="第一行表头,A列波次号,B列订单号,C列SKU,D列备注,E列一级原因,F列二级原因"
                    placement="top-start"
                  >
                    <el-upload
                      :action="action4"
                      name="file"
                      :limit="1"
                      :on-success="importFileSpot"
                      :file-list="fileList"
                      auto-upload
                      with-credentials
                    >
                      <el-button type="primary">导入不赔商品原因</el-button>
                    </el-upload>
                  </el-tooltip>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="handleBatchRecheck">
                    批量重新校验
                  </el-button>
                </el-form-item>

                <el-form-item>
                  <el-button
                    type="primary"
                    @click="express100FormVisible = true"
                  >
                    导入波次重跑快递优选
                  </el-button>
                </el-form-item>
                <el-dialog
                  v-loading="loading"
                  title="导入波次重跑快递优选"
                  :visible.sync="express100FormVisible"
                >
                  <span
                    >根据所提供的的波次单号,重跑快递优选给出最新的快递公司。此操作不影响波次其他状态。单次最多2000个波次单。</span
                  >
                  <el-form :model="form">
                    <el-form-item label="">
                      <el-upload
                        ref="upload"
                        :action="action2"
                        name="excel"
                        :limit="1"
                        :on-success="importFileExpress100"
                        :file-list="fileList"
                        :auto-upload="true"
                        with-credentials
                      >
                        <el-button slot="trigger" size="mini" type="primary">
                          选择文件
                        </el-button>
                      </el-upload>
                      <el-button size="mini" @click="exportExpress100Task">
                        导出文件模版
                      </el-button>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="express100FormVisible = false"
                      >取 消</el-button
                    >
                    <!--<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>-->
                    <el-button type="primary" @click="importExpress100Task">
                      提 交
                    </el-button>
                  </div>
                </el-dialog>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            min-height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;波次单数量：{{
              resData.total
            }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;波次商品待发数量：{{
              resData.sku_num
            }}
          </div>
          <div
            style="
              display: flex;
              flex: 1;
              flex-flow: row wrap;
              align-items: center;
              justify-content: right;
            "
          >
            <el-upload
              :action="action5"
              name="excel"
              :limit="1"
              :on-success="importOrderDelivery"
              :file-list="fileList"
              :show-file-list="false"
              auto-upload
              with-credentials
              style="margin-right: 8px; padding-bottom: 2px"
            >
              <el-button type="primary" size="mini">订单导入发货</el-button>
            </el-upload>

            <el-button
              type="primary"
              size="mini"
              @click="isShowDialogTailOrder = true"
            >
              尾货折销导入发货
            </el-button>
            <el-button
              style="margin-right: 10px"
              type="info"
              size="mini"
              @click="handlePrintExpressOrderDialogOpen"
            >
              快速重打面单
            </el-button>
            <el-dialog title="快速重打面单" :visible.sync="printExpressOrder">
              <el-form :model="form">
                <el-form-item label="请输入波次单">
                  <el-input
                    ref="wave_picking_no"
                    v-model="form.wave_picking_no"
                    placeholder="请输入波次单"
                    @keyup.native.enter="rePrintExpressOrder"
                  ></el-input>
                </el-form-item>
                <el-form-item label="快麦唯一识别码">
                  <el-input
                    v-model="form.unique_code"
                    placeholder="快麦唯一识别码"
                    @blur="handleUniqueCodeBlur"
                  ></el-input>
                </el-form-item>
              </el-form>
            </el-dialog>
            <el-date-picker
              v-if="show_all_time == 1"
              v-model="form.all_time"
              style="margin-right: -30px"
              size="mini"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['06:00:00', '06:00:00']"
            >
            </el-date-picker>
            <el-button
              style="margin-right: -15px"
              type="info"
              size="mini"
              @click="show_all_time = !show_all_time"
              ><i class="el-icon-date"
            /></el-button>
            <el-button type="info" size="mini" @click="outputall">
              导出全部波次单
            </el-button>
            <el-button type="danger" size="mini" @click="mergeWavePickingBatch">
              一键合并波次</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="unlockWavePickingByIds"
            >
              批量解锁</el-button
            >
            <el-button type="danger" size="mini" @click="mergeWavePicking">
              合并波次
            </el-button>
            <el-button type="danger" size="mini" @click="waybillDiscard">
              取消面单
            </el-button>
            <el-button type="success" size="mini" @click="printWavePicking">
              打印配货单
            </el-button>
            <el-button size="mini" @click="printWayBill">
              批量打印面单
            </el-button>
            <el-button
              style="margin-right: 10px"
              type="success"
              size="mini"
              @click="stockWpOutPicking"
            >
              囤货波次出库拣货
            </el-button>
            <el-button
              style="margin-right: 10px"
              type="success"
              size="mini"
              @click="shippingVisible = true"
              >修改快递公司</el-button
            >
            <field-setting page="1" @onsuccess="changeFields"></field-setting>
          </div>
        </div>
        <div v-if="resData.data" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_no"
              label="波次号"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sender_type"
              label="寄件人信息"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.user_id"
              prop="user_id"
              label="用户ID"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.consignee"
              prop="consignee"
              label="收货人姓名"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_full_allot"
              prop="wave_picking_full_allot"
              label="是否配齐"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_type"
              label="波次类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="quality_level"
              label="质检标准"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="hg_code"
              label="中分位"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_is_generate_picking_task"
              prop="wave_picking_is_generate_picking_task"
              label="是否生成拣货任务"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_mobile_hide"
              prop="wave_picking_mobile_hide"
              label="收货人手机"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.address"
              prop="address"
              label="收货人地址"
              show-overflow-tooltip
              align="left"
              width="200"
            >
              <template #default="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  @click="beforeChangeAddress(scope.row)"
                ></el-button>
                <span>{{ scope.row.address }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.shipping_company"
              prop="shipping_company"
              label="快递公司"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.guarantee_value_formal"
              prop="guarantee_value_formal"
              label="是否保价"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sender"
              label="网点"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shipping_type_formal"
              label="快递公司分配方式"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_is_put_picking_list"
              prop="wave_picking_is_put_picking_list"
              label="是否放置配货单"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  @click="updateFields(scope.row, 'PutList')"
                ></el-button>
                <span>{{ scope.row.wave_picking_is_put_picking_list }}</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="showFields.is_delivery_formal"
              prop="is_delivery_formal"
              label="是否催发"
              width="100"
              align="center"
            ></el-table-column>

            <el-table-column
              v-if="showFields.custom_note"
              key="custom_note"
              prop="custom_note"
              label="用户备注"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <template
                  v-for="(custom_value, custom_key) in scope.row.custom_note"
                >
                  <span v-if="custom_value" :key="custom_key">
                    {{ custom_key + 1 }}.{{ custom_value }}
                    <br />
                  </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.admin_note"
              key="admin_note"
              prop="admin_note"
              label="客服备注"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <template
                  v-for="(admin_value, admin_key) in scope.row.admin_note"
                >
                  <span v-if="admin_value" :key="admin_key">
                    {{ admin_key + 1 }}.{{ admin_value }}<br />
                  </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.ck_remark"
              key="ck_remark"
              prop="ck_remark"
              label="仓库备注"
              width="100"
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  @click="seCkRemark(scope.row)"
                ></el-button>
                <span>{{ scope.row.ck_remark }}</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="showFields.wave_picking_picking_type"
              prop="wave_picking_picking_type"
              label="拣货属性"
              width="200"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  @click="updateFields(scope.row, 'PickingType')"
                ></el-button>
                <span>{{ scope.row.wave_picking_picking_type }}</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="showFields.shipping_num"
              key="shipping_num"
              prop="shipping_num"
              label="快递单号"
              show-overflow-tooltip
              align="center"
              width="200"
            >
              <template #default="scope">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  @click="beforeChangeShipping(scope.row)"
                ></el-button>
                <span>{{ scope.row.shipping_num }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_num"
              prop="wave_picking_num"
              label="待发货商品数量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.pre_weight"
              prop="pre_weight"
              label="计算重量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.weight"
              prop="weight"
              label="实际(结算)重量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_print_status"
              prop="wave_picking_print_status"
              label="面单状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_pay_way"
              prop="wave_picking_pay_way"
              label="支付方式"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.order_sn"
              key="order_sn"
              prop="order_sn"
              label="订单号"
              width="180"
              align="center"
            >
              <template #default="scope">
                <template
                  v-for="(order_value, order_key) in scope.row.order_sn"
                >
                  <a
                    v-if="order_value"
                    :key="order_key"
                    class="_order_sn_item"
                    :class="{
                      _order_sn_item_color:
                        resData.wait_allot_order_sn.indexOf(order_value) === -1,
                    }"
                    @click="getOrderId(order_value)"
                  >
                    {{ order_key + 1 }}.{{ order_value }}
                    <span
                      v-if="
                        resData.spot_order_sn[scope.row.wave_picking_id] &&
                        resData.spot_order_sn[
                          scope.row.wave_picking_id
                        ].indexOf(order_value) !== -1
                      "
                      class="spot_order"
                      >现</span
                    >
                    <span
                      v-if="
                        resData.prior_order_sn[scope.row.wave_picking_id] &&
                        resData.prior_order_sn[
                          scope.row.wave_picking_id
                        ].indexOf(order_value) !== -1
                      "
                      class="spot_order yellow"
                      >优</span
                    >
                    <br />
                  </a>
                </template>
              </template>
            </el-table-column>

            <el-table-column
              v-if="showFields.create_time"
              prop="create_time"
              label="波次生成时间"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.shipments_date"
              prop="shipments_date"
              label="预计发货日期"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_is_stop_shipping"
              prop="wave_picking_is_stop_shipping"
              label="是否拦截"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.update_time"
              prop="update_time"
              label="更新时间"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.sk_time"
              prop="sk_time"
              label="最近物流时间"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.sk_content"
              prop="sk_content"
              label="最近物流信息"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.shipping_kdniao_state"
              prop="shipping_kdniao_state"
              label="物流状态"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_is_stock"
              prop="wave_picking_is_stock"
              label="是否囤货"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="showFields.wave_picking_ext_same_day_shipping"
              prop="wave_picking_ext_same_day_shipping"
              label="是否即日发"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >查看</el-button
                ><br
                  v-if="scope.row.status == 4 && scope.row.print_status != 1"
                />
                <el-button
                  v-if="scope.row.status == 4 && scope.row.print_status != 1"
                  type="text"
                  size="small"
                  @click="reCheck(scope.row)"
                  >重新校验</el-button
                ><br
                  v-if="
                    scope.row.print_status == 1 || scope.row.print_status == 6
                  "
                />
                <el-button
                  v-if="scope.row.print_status == 1"
                  type="text"
                  style="color: #67c23a"
                  size="small"
                  @click="rePrint(scope.row)"
                  >打印面单</el-button
                ><br />
                <el-button
                  v-if="scope.row.status === '5'"
                  type="text"
                  style="color: #67c23a"
                  size="small"
                  @click="printNew(scope.row)"
                  >打印新面单</el-button
                ><br />
                <el-button
                  type="text"
                  style="color: red"
                  size="small"
                  @click="beforeSplit(scope.row.wave_picking_id)"
                  >拆分波次</el-button
                ><br v-if="scope.row.wave_picking_summary_id != 0" />
                <el-button
                  v-if="scope.row.wave_picking_summary_id != 0"
                  type="text"
                  style="color: orange"
                  size="small"
                  @click="unLockWavePicking(scope.row.wave_picking_id)"
                  >解锁</el-button
                ><br />
                <div v-if="scope.row.is_stock == 1">
                  <el-button
                    type="text"
                    style="color: gray"
                    size="small"
                    @click="
                      setStock(scope.row.wave_picking_id, 2, scope.$index)
                    "
                    >解除囤货</el-button
                  >
                </div>
                <div v-if="scope.row.is_stock == 2">
                  <el-button
                    type="text"
                    style="color: gray"
                    size="small"
                    @click="
                      setStock(scope.row.wave_picking_id, 1, scope.$index)
                    "
                    >标记囤货</el-button
                  >
                </div>
                <div v-if="scope.row.is_stop_shipping == 2">
                  <el-button
                    type="text"
                    size="small"
                    @click="toStop(scope.row.wave_picking_id, 1, scope.$index)"
                    >拦截</el-button
                  >
                </div>
                <div v-if="scope.row.is_stop_shipping == 1">
                  <el-button
                    type="text"
                    size="small"
                    @click="toStop(scope.row.wave_picking_id, 2, scope.$index)"
                    >取消拦截</el-button
                  >
                </div>
                <br v-if="form.dbid && scope.row.status < 4" />
                <el-button
                  v-if="form.dbid && scope.row.status < 4"
                  type="text"
                  size="small"
                  @click="wavePickingRearrange(scope.row)"
                  >改排</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.total"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
        <el-dialog
          title="请选择快递公司"
          :visible.sync="shippingVisible"
          @close="handleShippingDialogClose"
        >
          <el-form :model="form">
            <el-form-item label="快递公司">
              <el-select
                v-model="form.express"
                placeholder="请选择快递公司"
                @change="getSenders"
              >
                <el-option
                  v-for="express in conditionData.express"
                  :key="express"
                  :label="express"
                  :value="express"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.express !== '物流'" label="网点">
              <el-select v-model="form.sender_id" placeholder="请选择网点">
                <el-option label="无" value="0"></el-option>
                <el-option
                  v-for="item in senders"
                  :key="item.sender_id"
                  :label="item.sender"
                  :value="item.sender_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.express === '物流'" label="物流公司">
              <el-select v-model="form.logistics_id" placeholder="请选择网点">
                <el-option label="无" value="0"></el-option>
                <el-option
                  v-for="item in conditionData.logistics"
                  :key="item.logistics_id"
                  :label="item.logistics_name"
                  :value="item.logistics_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="更新数据范围">
              <el-select
                v-model="form.update_shipping_type"
                placeholder="更新数据范围"
              >
                <el-option label="选择的波次修改" value="0"></el-option>
                <el-option label="按查询条件修改" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footeidr">
            <el-button
              @click="
                shippingVisible = false;
                senders = [];
              "
              >取 消</el-button
            >
            <el-button type="primary" @click="updateShipping(0)">
              确 定
            </el-button>
          </div>
        </el-dialog>
        <el-dialog title="输入修改地址" :visible.sync="changeAddressVisible">
          <el-form :model="form">
            <el-form-item>
              <el-input
                v-model="form.change_consignee"
                placeholder="收件人"
                @keyup.native.enter="search"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="form.change_wave_picking_mobile_hide"
                placeholder="手机"
                @keyup.native.enter="search"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="form.change_province"
                placeholder="省"
                @change="getCity"
              >
                <el-option
                  v-for="item in conditionData.province"
                  :key="item.region_id"
                  :label="item.region_name"
                  :value="item.region_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="form.change_city"
                placeholder="市"
                @change="getDistrict"
              >
                <el-option
                  v-for="item in cityData.list"
                  :key="item.region_id"
                  :label="item.region_name"
                  :value="item.region_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="form.change_district" placeholder="区">
                <el-option
                  v-for="item in districtData.list"
                  :key="item.region_id"
                  :label="item.region_name"
                  :value="item.region_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="form.change_address"
                placeholder="详细地址"
                @keyup.native.enter="search"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              type="danger"
              style="float: left"
              @click="recoveryConsignee(1)"
              >恢复至下单的收件信息</el-button
            >
            <el-button @click="changeAddressVisible = false">取 消</el-button>
            <el-button type="primary" @click="changeAddress">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="改排最多件"
          :visible.sync="delVisible"
          width="30%"
          center
        >
          <el-form :model="form">
            <el-form-item label="改排" prop="delNum">
              <el-input v-model="form.delNum" type="number" :max="skuNum">
                <template #append> 件,最多{{ skuNum }}件 </template>
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="delVisible = false">取 消</el-button>
            <el-button type="primary" @click="doRearrange()">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="选择要拆分的订单" :visible.sync="splitVisible">
          <el-form :model="form">
            <el-form-item label="选择要拆分的订单">
              <el-checkbox-group v-model="form.split_orders">
                <el-checkbox
                  v-for="order in orders"
                  :key="order.order_id"
                  :label="order.order_id"
                  >{{ order.order_sn }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="splitVisible = false">取 消</el-button>
            <el-button type="primary" @click="doSplit">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="备注" :visible.sync="ckRemarkVisible">
          <el-form :model="form">
            <el-form-item>
              <el-input v-model="form.remark" placeholder="备注"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="ckRemarkVisible = false">取 消</el-button>
            <el-button type="primary" @click="doRemark">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="修改快递信息" :visible.sync="changeShippingVisible">
          <el-form :model="form">
            <el-form-item label="快递公司">
              <el-select
                v-model="form.change_shipping_company"
                placeholder="请选择快递公司"
              >
                <el-option
                  v-for="express in conditionData.all_express"
                  :key="express"
                  :label="express"
                  :value="express"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="快递单号">
              <el-input
                v-model="form.change_shipping_num"
                style="width: 250px; margin: 0"
                placeholder="快递单号"
                @keyup.native.enter="search"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="changeShippingVisible = false">取 消</el-button>
            <el-button type="primary" @click="changeShipping">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <!--数据统计-->
    <div v-if="show_statistics">
      <statistics @onCloseDialog="show_statistics = false"></statistics>
    </div>
    <!-- 囤货弹窗 -->
    <el-dialog title="囤货设置" :visible.sync="keepStock.isShow" width="600px">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="到日期发货">
          <el-date-picker
            v-model="keepStock.form.limit_ship_date"
            :picker-options="{
              disabledDate: (time) =>
                time.getTime() + 24 * 60 * 60 * 1000 < Date.now(),
            }"
            :clearable="true"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="配齐数量发货">
          <el-input-number
            v-model="keepStock.form.limit_ship_num"
            :controls="false"
            type="number"
            :min="0"
          ></el-input-number
          ><span style="margin-left: 10px">PCS</span>
          <el-checkbox
            v-model="keepStock.form.is_full_allot_ship"
            true-label="1"
            false-label="2"
            style="margin-left: 20px"
            >配齐发货</el-checkbox
          >
        </el-form-item>
        <el-form-item label="配齐订单发货">
          <div style="display: flex">
            <div class="_order_ids">
              <div
                v-for="(item, index) in keepStock.form.limit_ship_order_ids"
                :key="index"
                class="_order_ids_item"
              >
                {{ item.order_sn }}
              </div>
            </div>
            <i class="el-icon-plus _icon_plus" @click="showOrderid" />
          </div>
        </el-form-item>
        <el-input
          v-model="keepStock.form.stock_remark"
          type="textarea"
          placeholder="备注"
        ></el-input>
      </el-form>
      <div slot="footer">
        <div v-if="keepStock.action == 1">
          <el-button type="primary" @click="saveKeepStock">囤货</el-button>
          <el-button type="infor" @click="keepStock.isShow = false">
            取消</el-button
          >
        </div>
        <div v-if="keepStock.action == 2">
          <el-button type="primary" @click="saveKeepStock">保存</el-button>
          <el-button type="danger" @click="cancelKeepStock">取消囤货</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 获取订单号弹窗 -->
    <el-dialog
      title="选择订单号"
      :visible.sync="keepStock.order_id.isShow"
      width="400px"
    >
      <el-table
        ref="orderSelectionTable"
        :data="keepStock.order_id.ids"
        @selection-change="orderSelection"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          label="订单id"
          prop="order_id"
          align="left"
        ></el-table-column>
        <el-table-column
          label="订单号"
          prop="order_sn"
          align="left"
        ></el-table-column>
      </el-table>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="orderIdComfirm">确定</el-button>
        <el-button type="infor" @click="orderIdCancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 尾货折销导入发货弹窗 -->
    <el-dialog
      title="尾货折销-导入打标ID完成发货"
      :visible.sync="isShowDialogTailOrder"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form
        ref="formTailOrder"
        :model="formTailOrder"
        :rules="formTailOrderRules"
      >
        <el-form-item label="用户订单编号" prop="order_id">
          <ys-input v-model="formTailOrder.order_id"></ys-input>
        </el-form-item>
        <el-form-item label="波次商品打标ID" prop="excel">
          <input
            ref="input"
            style="display: none"
            type="file"
            @change="handleFileChange"
          />
          <el-button type="primary" size="small" @click="handleFileSelect">
            {{ formTailOrder.excel ? "替换文件" : "添加文件" }}
          </el-button>
          <el-tag
            v-if="formTailOrder.excel"
            style="margin: 0 8px"
            closable
            @close="handleFileRemove"
            >{{ formTailOrder.excel.name }}</el-tag
          >
          <el-button size="small" @click="handleTailOrderTempExport">
            导出文件模版
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button
          :loading="loadingSubmitTail"
          @click="isShowDialogTailOrder = false"
        >
          取消
        </el-button>
        <el-button
          :loading="loadingSubmitTail"
          type="primary"
          @click="handleConfirmTailOrder"
        >
          提交
        </el-button>
      </div>
    </el-dialog>

    <excel-import ref="excelImport"></excel-import>

    <!-- 打印新面单 -->
    <el-dialog title="请选择打印的快递公司" :visible.sync="printNewVisible">
      <el-form :model="printNewForm">
        <el-form-item label="快递公司">
          <el-select
            v-model="printNewForm.express"
            placeholder="请选择快递公司"
            @change="getSenders"
          >
            <el-option
              v-for="express in conditionData.express"
              :key="express"
              :label="express"
              :value="express"
              :disabled="express === '物流'"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="网点">
          <el-select v-model="printNewForm.sender_id" placeholder="请选择网点">
            <el-option label="无" value="0"></el-option>
            <el-option
              v-for="item in senders"
              :key="item.sender_id"
              :label="item.sender"
              :value="item.sender_id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footeidr">
        <el-button
          @click="
            printNewVisible = false;
            senders = [];
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="handlePrintNewExpress">
          确 定（请确认打印机是否正常）</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import { cloneDeep } from "lodash-es";

import rules from "@/const/rules.js";
import * as halveGroup from "@/controller/halveGroup.js";
import * as wavePickApi from "@/controller/wavePick.js";
import * as wavePicking from "@/openapi/erp/wavePicking.js";
import { openDownloadWindow } from "@/utils/export.js";
import excelImport from "./components/ExcelImport.vue";
import fieldSetting from "./components/fieldSetting.vue";
import statistics from "./components/Statistics.vue";

const constEnum = {
  limit: 1,
  IS_NET_SHOP_ORDER: "1", // 是网商的订单
};

export default {
  components: { fieldSetting, statistics, excelImport },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
      console.log("---vm.form", vm.form);
      if (vm.form.picking_assignment_no || vm.form.wave_picking_no) {
        vm.search();
      }
    });
  },
  data() {
    const pickingAssignmentNo = this.$route.params.picking_assignment_no || 0;
    const searchType = this.$route.query.search_type || "";
    return {
      constEnum,
      keepStock: {
        // 囤货信息
        isShow: false,
        form: {
          wave_picking_id: 0,
          kssid: 0, // 囤货id
          limit_ship_date: "",
          limit_ship_num: "",
          is_full_allot_ship: "2",
          limit_ship_order_ids: [],
          stock_remark: "",
        },
        action: 1, // {1: 囤货, 2:取消囤货}
        updating: {},

        order_id: {
          isShow: false,
          ids: [],
          order_nos: [],
          selection: [],
        },
      },

      resData: {
        setting: "未配置数据",
      },
      is_show_search_option: false,
      conditionData: {},
      cityData: {},
      districtData: {},
      search_type:
        searchType ||
        (pickingAssignmentNo ? "picking_assignment_no" : "wave_picking_no"),
      search_options: [
        { key: "picking_assignment_no", name: "拣货任务单号" },
        { key: "wave_picking_no", name: "波次号" },
        { key: "dbid", name: "打标id" },
        { key: "sku", name: "SKU" },
        { key: "order_sn", name: "订单号" },
        { key: "goods_no", name: "商品货号" },
        { key: "user_id", name: "用户id" },
        { key: "mobile", name: "收件人手机号" },
        { key: "shipping_num", name: "快递单号" },
        { key: "quality_label_summary_id", name: "汇总id" },
      ],
      twoType: [],
      form: {
        order_create_time: this.defaultDate(),
        create_time: pickingAssignmentNo
          ? []
          : this.$excalibur.getDateTimeOnHours(-3, 6),
        log_time: this.$excalibur.getDateTimeOnHours(-30, 6),
        label_time: this.labelDate(),
        gp_time: this.labelDate(),
        multipleSelection: [],
        split_orders: [],
        note_without_num: 0,
        dbid: "",
        is_pu: 1,
        remark_wave_picking_id: 0,
        change_shipping_company: "0",
        change_shipping_num: 0,
        task_type: 2,
        pagesize: 100,
        remark: "",
        picking_assignment_no:
          searchType === "wave_picking_no" ? "" : pickingAssignmentNo,
        wave_picking_no:
          searchType === "wave_picking_no" ? pickingAssignmentNo : "",
        // 兼容弹窗输入时不能输入东西的bug
        change_consignee: "",
        change_wave_picking_mobile_hide: "",
        change_province: "",
        change_city: "",
        change_district: "",
        change_address: "",
        is_remark: [],
        picking_type: [],
        user_search: "",
        two_type: [],
        user_net_worth_type: [],
        hgd_id: [], // 中分位id数组
        sender_id: "",
        is_today_shipments: "",
        unique_code: "", // 快麦唯一编码
      },
      show_log_time: 0,
      show_label_time: 0,
      show_gp_time: 0,
      loading: false,
      url: "/erp/WavePicking/getWavePickingList",
      origin: 1,
      type: 1,
      where: -1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      checkList: [],
      fileList: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormUserVisible: false,
      changeAddressVisible: false,
      changeShippingVisible: false,
      splitVisible: false,
      ckRemarkVisible: false,
      wave_picking_id: 0,
      param: "",
      is_summary: 0, // 勾选的是否有汇总单的数据
      noteData: [
        { note_id: "", note_name: "请选择" },
        { note_id: "is_no_invoice", note_name: "不放发货单" },
        { note_id: "is_quality_testing", note_name: "质检要求" },
        { note_id: "is_delivery", note_name: "催发货" },
        { note_id: "is_change_express", note_name: "快递选择" },
        { note_id: "is_send_logistics", note_name: "物流选择" },
        { note_id: "is_merge_order", note_name: "合并发货" },
        { note_id: "is_goods_explode_delivery", note_name: "商品拆分" },
        { note_id: "is_change_consignee", note_name: "修改寄件人" },
        { note_id: "is_change_address", note_name: "修改收件人" },
        { note_id: "is_other", note_name: "其他" },
      ],
      noteWithoutNumData: [
        // {"note_id" : '', "note_name" : "全部"},
        { note_id: 0, note_name: "无备注" },
        { note_id: 1, note_name: "未处理" },
        { note_id: 2, note_name: "已处理" },
      ],
      summary: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      is_pu_options: [
        { value: 0, label: "全部" },
        { value: 1, label: "是" },
        { value: 2, label: "否" },
      ],
      is_pq: [
        { key: 0, name: "全部" },
        { key: 1, name: "配齐" },
        { key: 2, name: "未配齐" },
        { key: 3, name: "今日配齐" },
      ],
      is_today_pq: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      is_stock: [
        { key: 0, name: "全部" },
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      payData: [
        { pay_id: 0, pay_name: "全部" },
        { pay_id: 1, pay_name: "在线支付" },
        { pay_id: 2, pay_name: "货到付款" },
      ],
      sender_type: [
        { key: 0, name: "全部" },
        { key: 1, name: "系统来源" },
        { key: 2, name: "用户来源" },
      ],
      shippingAction: "",
      shippingVisible: false,
      printExpressOrder: false,
      websock: null,
      orders: [{}],
      skuNum: 0,
      delVisible: false,
      statusList: {},
      form2: {
        timeType: 1,
      },
      printDatas: [],
      print_key: 0,
      show_all_time: 0,
      showFields: {},
      show_statistics: false,
      search_value: pickingAssignmentNo || "",
      senders: [],
      printNewVisible: false,
      printNewForm: {
        express: "",
        sender_id: "",
      },
      currentRow: null,
      hgCodeByHgList: [], // 中分位查询数据
      // 中分为联级多选，改为动态加载的方式
      hgCodeByHgProps: {
        multiple: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, value = 0 } = node;

          // 如果是根目录，则取出一级数据
          if (level === 0) {
            const list = this.hgCodeByHgList?.map((item) => {
              return {
                ...item,
                leaf: level >= 1,
              };
            });

            resolve(list);
          } else {
            // 根据当前ID，查找子集
            const postData = {
              hg_id: value,
            };
            halveGroup.getHgCodeByHgId(postData).then((res) => {
              const list = res.map((item) => {
                return {
                  value: item.hgd_id,
                  label: item.hg_code,
                  leaf: level >= 1,
                };
              });
              resolve(list);
            });
          }
        },
      },
      isShowDialogTailOrder: false, // 尾货折销弹窗
      formTailOrder: {
        order_id: "",
        excel: "",
      },
      formTailOrderRules: {
        order_id: rules.ruleBlur,
        excel: rules.ruleChange,
      },
      loadingSubmitTail: false,
      express100FormVisible: false,
      formExpress100Task: {
        file_list: "",
        task_type: 2,
      },
      action1: `${apiBaseURL}/erp/WavePicking/importWeight`,
      action2: `${apiBaseURL}/erp/WavePicking/importFile`,
      action3: `${apiBaseURL}/erp/WavePicking/importShippingInfo`,
      action4: `${apiBaseURL}/erp/WavePickingInfo/importPayOutSpotReason`,
      action5: `${apiBaseURL}/erp/WavePicking/importAllotOrder`, // 导入订单生成波次
    };
  },
  computed: {
    filteredForm() {
      const form = cloneDeep(this.form);
      // 将一个二维数组中的最后一个值转为一维数组
      form.hgd_id = form?.hgd_id?.map((item) => item[item.length - 1]);

      if (this.search_value !== "") {
        form[this.search_type] = this.search_value;
      } else {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const key in this.search_options) {
          form[this.search_options[key].key] = "";
        }
      }
      return form;
    },
    userSearchCount() {
      if (this.form.user_search !== "") {
        return Array.from(
          new Set(this.form.user_search.split(/\D+/).filter(Boolean))
        ).length;
      }
      return 0;
    },
  },
  created() {
    this.initWebSocket();
  },
  destroyed() {
    // 页面销毁时关闭长连接
    this.websocketclose();
  },
  methods: {
    handlePrintExpressOrderDialogOpen() {
      this.printExpressOrder = true;
      this.form.unique_code = localStorage.getItem("km_unique_code") || "";
    },
    handleUniqueCodeBlur() {
      localStorage.setItem("km_unique_code", this.form.unique_code);
    },
    stockWpOutPicking() {
      console.log(this.form.multipleSelection);
      // 获取列表已选中的数据
      wavePicking
        .postStockWpOutPicking({
          ids: this.form.multipleSelection,
        })
        .then((res) => {
          this.$message.success(res.msg);
        });
    },
    // 用户层级标签
    changeTwoType(e) {
      const selectList = e || [];
      this.form.two_type = [];
      selectList.forEach((item) => {
        this.form.two_type.push(item[1]);
      });
    },
    getSenders(val) {
      this.senders = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.conditionData.senders) {
        if (this.conditionData.senders[key].shipping_company === val) {
          this.senders.push(this.conditionData.senders[key]);
        }
      }
      this.form.sender_id = "";
      this.form.logistics_id = "";
      this.printNewForm.sender_id = "";
      console.log(this.senders);
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
    },
    tableRowClassName({ row }) {
      if (String(row.is_stock) === "1") {
        return "stock-row";
      }
      return "";
    },
    beforeSplit(wavePickingId) {
      this.$router.push(`/home/wavepicking/splitwavepicking/${wavePickingId}`);
    },
    doSplit() {
      this.$http
        .post("/erp/WavePicking/doSplit", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.form.split_orders = [];
            this.fetchData(true);
            this.splitVisible = false;
          }
        });
    },
    changeAddress() {
      this.$http
        .post(
          `/erp/WavePicking/changeAddress/wave_picking_id/${this.wave_picking_id}`,
          this.filteredForm
        )
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.fetchData(true);
            this.$set(this.form, "change_province", "");
            this.$set(this.form, "change_city", "");
            this.$set(this.form, "change_district", "");
            this.$set(this.form, "change_address", "");
            this.changeAddressVisible = false;
          }
        });
    },
    beforeChangeAddress(row) {
      this.getCity(row.province);
      this.getDistrict(row.city);

      this.wave_picking_id = row.wave_picking_id;
      this.$set(this.form, "change_province", row.province);
      this.$set(this.form, "change_city", row.city);
      this.$set(this.form, "change_district", row.district);
      this.$set(this.form, "change_address", row.address);
      this.$set(this.form, "change_consignee", row.consignee);
      this.$set(
        this.form,
        "change_wave_picking_mobile_hide",
        row.wave_picking_mobile_hide
      );
      this.changeAddressVisible = true;
    },
    beforeChangeShipping(row) {
      this.wave_picking_id = row.wave_picking_id;
      this.form.change_shipping_company = row.shipping_company;
      this.form.change_shipping_num = row.shipping_num;
      this.changeShippingVisible = true;
    },
    updateFields(row, field) {
      this.$confirm("确认修改?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post(`/erp/WavePicking/update${field}`, {
              wave_picking_id: row.wave_picking_id,
              field,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    changeShipping() {
      this.$http
        .post(
          `/erp/WavePicking/changeShipping/wave_picking_id/${this.wave_picking_id}`,
          this.filteredForm
        )
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.fetchData(true);
            this.form.change_shipping_company = "0";
            this.form.change_shipping_num = 0;
            this.changeShippingVisible = false;
          }
        });
    },
    seCkRemark(row) {
      this.wave_picking_id = row.wave_picking_id;
      this.form.remark = row.ck_remark;
      this.ckRemarkVisible = true;
    },
    doRemark() {
      this.$http
        .post("/erp/WavePicking/setCkRemark", {
          wave_picking_id: this.wave_picking_id,
          remark: this.form.remark,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.wave_picking_id = 0;
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData(true);
              this.ckRemarkVisible = false;
            }
          }
        });
    },
    gen_wave() {
      this.$confirm("是否确定生成波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/GenerateWavePicking/", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                this.form.is_excel = 0;
                if (res.data.code !== 200) {
                  this.$message.e(res.data.msg);
                } else {
                  this.$message.success(res.data.msg);
                  this.fetchData(true);
                }
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    gen_summary() {
      this.$confirm("是否确定生成汇总单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/summary", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                this.form.is_excel = 0;
                if (res.data.code !== 200) {
                  this.$message.e(res.data.msg);
                } else {
                  this.$message.success(res.data.msg);
                  this.fetchData(true);
                }
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    lockWavePicking(val) {
      if (`${val}` === "1") {
        this.filteredForm.is_force = 1;
      } else {
        this.filteredForm.is_force = 0;
      }
      // 杭州的质检 或 杭州广州的有备注才可以使用锁定按钮
      this.$http
        .post("/erp/WavePicking/beforeLock", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            const h = this.$createElement;
            const {
              count,
              wave_picking_num: wavePickingNum,
              morrow_count: morrowCount,
              morrow_date: morrowDate,
            } = res.data.data;
            const confirmText = [
              h(
                "p",
                null,
                `确定锁定波次?   波次数量：${count}  商品数量：${wavePickingNum}`
              ),
            ];
            if (morrowCount) {
              confirmText.push(
                h(
                  "p",
                  { style: "color: #f56c6c" },
                  `注意：所选的波次单包含${morrowCount}条预计${morrowDate}号发的数据，请慎重锁定波次！`
                )
              );
            }
            this.$confirm("", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              message: h("div", null, confirmText),
            })
              .then(() => {
                this.$http
                  .post("/erp/WavePicking/lockWavePicking", this.filteredForm)
                  .then((result) => {
                    if (result.data.code !== 200) {
                      this.$message.e(result.data.msg);
                    } else {
                      this.form.is_excel = 0;
                      if (result.data.code !== 200) {
                        this.$message.e(result.data.msg);
                      } else {
                        this.$message.e(result.data.msg);
                        this.fetchData(true);
                      }
                    }
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消操作",
                });
              });
          }
        });
    },
    // 一键批量合并波次
    mergeWavePickingBatch() {
      this.$http
        .post("/erp/WavePicking/beforeMergeWavePickingBatch", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.$confirm(
              `可合并波次有${res.data.data.merge_total}个，可合并为${res.data.data.merge_num}个波次，是否合并？`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.$http
                  .post(
                    "/erp/WavePicking/mergeWavePickingBatch",
                    this.filteredForm
                  )
                  .then((result) => {
                    if (result.data.code !== 200) {
                      this.$message.e(result.data.msg);
                    } else {
                      this.form.is_excel = 0;
                      this.$message.success(result.data.msg);
                      this.fetchData(true);
                    }
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消操作",
                });
              });
          }
        });
    },

    // 生成拣货任务之前检查
    generateTaskBefore() {
      this.$http
        .post("/erp/WavePicking/countingWavePicking", {
          the_ids: this.form.multipleSelection,
          generate_type: 1,
        })
        .then((rs) => {
          if (`${rs.data.code}` !== "200") {
            this.$message.e(rs.data.msg);
            return;
          }
          const d = rs.data.data;
          const msg = `已锁定波次数量: ${d.is_lock}, 单波次数量: ${d.picking_type_1}, 多波次数量: ${d.picking_type_2};   `;
          this.generateTask(msg);
        })
        .catch(() => {
          return this.$message.e("获取数据错误, 请联系管理员");
        });
    },

    // 批量重新校验
    handleBatchRecheck() {
      this.$confirm("是否确定重新校验?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/batchReCheck", {
              wave_picking_ids: this.form.multipleSelection,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    generateTask(msg) {
      this.$confirm(`${msg}是否确定生成拣货任务?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/PickingAssignment/generatePickingAssignment", {
              the_ids: this.form.multipleSelection,
              generate_type: 1,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                const showCancelButton = false;
                this.$confirm(res.data.msg, "拣货任务生成结果", {
                  showCancelButton,
                });
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    unlockWavePickingByIds() {
      this.$confirm("是否确定解锁波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/unLockWavePickingByIds", {
              wave_picking_ids: this.form.multipleSelection,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    unLockWavePicking(wavePickingId) {
      this.$confirm("是否确定解锁波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/unLockWavePicking", {
              wave_picking_id: wavePickingId,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    wavePickingRearrange(row) {
      this.form.rearrange_wave_picking_id = row.wave_picking_id;
      if (String(row.wave_picking_num) === "1") {
        this.form.delNum = 1;
        this.$confirm("是否确认改排?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.doRearrange();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      } else {
        // 获取该dbid对应的sku能改排的数量
        this.$http
          .post("/erp/WavePickingInfo/getSkuNum", {
            wave_picking_id: row.wave_picking_id,
            dbid: this.form.dbid,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              this.skuNum = res.data.data.skuNum;
              this.delVisible = true;
            }
          });
      }
    },
    doRearrange() {
      // 获取该dbid对应的sku能改排的数量
      this.$http
        .post("/erp/WavePickingInfo/doRearrange", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.fetchData(true);
            this.delVisible = false;
          }
        });
    },

    setShipping() {
      this.$confirm("是否确定分配快递公司?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/setShipping", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.fetchData(true);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    updateShipping(isConfirm = 0) {
      this.$http
        .post("/erp/WavePicking/updateShipping", {
          express: this.form.express,
          sender_id: this.form.sender_id,
          logistics_id: this.form.logistics_id,
          multipleSelection: this.form.multipleSelection,
          update_shipping_type: this.form.update_shipping_type,
          is_confirm: isConfirm,
          ...this.filteredForm,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            if (res.data.code === 402) {
              this.$confirm(
                `<div style='max-height: 80vh;overflow: auto'>${res.data.msg}<div>`,
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  dangerouslyUseHTMLString: true,
                }
              )
                .then(() => {
                  this.updateShipping(1);
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消操作",
                  });
                });
            } else {
              this.$message.e(res.data.msg);
            }
          } else {
            this.shippingVisible = false;
            this.senders = [];
            this.$message.success(res.data.msg);
            this.fetchData(true);
          }
        });
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    defaultTempSummaryNo() {
      if (this.$route.params.quality_label_summary_id) {
        // this.form.create_time = this.searchDate()
        this.form.note_without_num = 6;
        this.search_type = "quality_label_summary_id";
        this.search_value = this.$route.params.quality_label_summary_id;
        this.form.quality_label_summary_id =
          this.$route.params.quality_label_summary_id;
        this.form.status = this.$route.params.status;
      }
    },
    searchDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    logDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    labelDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const start = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 00:00:00`;

      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;
      return [start, end];
    },
    output() {
      // this.form.is_excel = 1;
      this.loading = true;
      this.$http
        .post(this.url, { ...this.filteredForm, is_excel: 1 })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.loading = false;
            // this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    outputall() {
      // this.form.is_excel = 1;
      this.form.is_all_wave = 1;
      this.loading = true;
      this.$http
        .post(this.url, { ...this.filteredForm, is_excel: 1 })
        .then((res) => {
          if (res.data.code !== 200) {
            this.loading = false;
            this.$message.e(res.data.msg);
          } else {
            this.loading = false;
            // this.form.is_excel = 0;
            this.form.is_all_wave = 0;
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    outputLog() {
      this.loading = true;
      this.form.origin = this.origin; // Ensure origin is set in the form
      this.$http
        .post("/erp/WavePicking/getWavePickingLog", {
          ...this.filteredForm,
          origin: this.form.origin, // Pass the origin field
          is_excel: 1,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    outputExpress() {
      // this.form.is_excel = 1;
      this.loading = true;
      this.form.origin = this.origin;
      this.form.is_express = 1;
      this.$http
        .post(this.url, { ...this.filteredForm, is_excel: 1 })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.loading = false;
            // this.form.is_excel = 0;
            this.form.is_express = 0;
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    userSearchCancel() {
      this.form.user_search = "";
      this.dialogFormUserVisible = false;
    },
    outputInfo() {
      // this.form.is_excel = 1;
      this.loading = true;
      this.$http
        .post("/erp/WavePicking/exportWavePickingInfo/", {
          ...this.filteredForm,
          is_excel: 1,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            // this.form.is_excel = 0;
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    outputLabel() {
      // this.form.is_excel = 1;
      this.loading = true;
      this.$http
        .post("/erp/WavePicking/exportAlterLabelDetail", {
          ...this.filteredForm,
          is_excel: 1,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.loading = false;
            // this.form.is_excel = 0;
            this.$message.e(res.data.msg);
          } else {
            // this.form.is_excel = 0;
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    // 改排重配明细导出
    outputReAllotLog() {
      this.form.origin = this.origin;
      this.$http
        .post("/erp/WavePicking/getWaveChangeAndReAllotLog", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      this.is_summary = 0;
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const key in val) {
        multipleSelection[key] = val[key].wave_picking_id;
        if (Number(val[key].wave_picking_summary_id) !== 0) this.is_summary = 1;
      }
      this.form.multipleSelection = multipleSelection;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(
        `/home/wavepicking/wavepickinginfo/${row.wave_picking_id}`
      );
    },
    reCheck(row) {
      this.$confirm("是否确定重新校验此波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/reCheck", {
              wave_picking_id: row.wave_picking_id,
              wave_picking_no: row.wave_picking_no,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                this.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    rePrint(row) {
      this.$confirm(
        "是否确定重新打印电子面单？（若无反应请刷新页面再打一次）",
        "提示",
        {
          confirmButtonText: "确定（请确认打印机是否正常）",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$http
            .post("/erp/WavePicking/rePirnt", {
              wave_picking_no: row.wave_picking_no,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.websocketsend(JSON.stringify(res.data.data.printData));
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    rePrintExpressOrder() {
      try {
        this.$http
          .post("/erp/WavePickingExpress/printExpressOrder", {
            wave_picking_no: this.form.wave_picking_no,
            unique_code: this.form.unique_code,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message({
                type: "info",
                message: res.data.msg,
              });
            } else if (
              res?.data?.data?.printData?.is_net_shop_order ===
              constEnum.IS_NET_SHOP_ORDER
            ) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
            } else {
              this.websocketsend(JSON.stringify(res.data.data.printData));
            }
          });
        this.form.wave_picking_no = "";
      } catch (error) {
        console.log("rePrintExpressOrder error: ", error);
        this.$message.e("打印失败");
      } finally {
        this.form.wave_picking_no = "";
        this.$refs.wave_picking_no.focus();
      }
    },
    printNew(row) {
      this.printNewVisible = true;
      this.currentRow = row;
    },
    handlePrintNewExpress() {
      const params = {
        wave_picking_id: this.currentRow.wave_picking_id,
        ...this.printNewForm,
      };
      wavePickApi
        .updateExpress(params)
        .then((res) => {
          this.printNewVisible = false;
          this.websocketsend(JSON.stringify(res));
        })
        .catch(this.$noop);
    },
    // websocket相关
    initWebSocket() {
      // 初始化weosocket

      const ishttps = document.location.protocol === "https:";
      let wsuri;
      if (ishttps) {
        wsuri = "wss://localhost:13529"; // https wss地址
      } else {
        wsuri = "ws://localhost:13528"; // ws地址
      }

      this.websock = new WebSocket(wsuri);
      // this.websocket.onopen = this.websocketonopen;

      this.websock.onerror = this.websocketonerror;

      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonerror() {
      // 错误
    },
    websocketonmessage(e) {
      const obj = JSON.parse(e.data);
      if (obj.cmd === "print") {
        if (obj.status === "failed") {
          this.$confirm(obj.msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        } else if (this.printDatas) {
          this.print_key += 1;
          if (this.print_key < this.printDatas.length) {
            this.websocketsend(JSON.stringify(this.printDatas[this.print_key]));
          } else {
            this.printDatas = [];
            this.fetchData(true);
          }
        } else {
          this.fetchData(true);
        }
      }
    },
    websocketsend(agentData) {
      // 数据发送
      this.websock.send(agentData);
    },
    websocketclose() {
      // 关闭
    },

    waveOrderList() {
      this.$router.push(`/home/wavepicking/waveorderlist`);
    },
    search() {
      this.form.page = 1;
      // this.form.is_excel = 0;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
          this.resData = res.data.data;
        } else {
          this.resData = res.data.data;
          this.curPage = 1;
        }
      });
    },
    fetchCondition() {
      this.defaultTempSummaryNo();
      if (this.$route.query.type) {
        this.form.type = this.$route.query.type;
        this.type = parseInt(this.$route.query.type, 10);
      }
      if (this.type === 4) {
        this.$router.push(`/home/aswavepicking/aswavepickinglist`);
      }
      // 获取状态统计
      this.fetchStatusList(0);
      if (
        this.$route.query.wave_picking_summary_id &&
        typeof this.form.wave_picking_summary_id === "undefined"
      ) {
        this.form.wave_picking_summary_id =
          this.$route.query.wave_picking_summary_id;
      }

      if (this.form.wave_picking_summary_id) {
        this.fetchData();
      } else if (this.$route.params.quality_label_summary_id) {
        this.form.create_time = [];
        this.fetchData();
      } else {
        this.$http
          .post("/erp/WavePicking/getWavePickingCondition", this.filteredForm)
          .then((res) => {
            if (res.data.code !== 200) {
              this.conditionData = res.data.data;
              this.$message.e(res.data.msg);
            } else {
              this.conditionData = res.data.data;
              this.origin = res.data.data.user_origin;
            }

            // 处理中分为分组，一级列表
            const hgCodeByHgList = res.data.data?.hg_show_id.map((item) => {
              return {
                value: item.hg_id,
                label: item.hg_show_id,
                children: [],
              };
            });
            this.hgCodeByHgList = hgCodeByHgList;
          });
      }
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (
        this.$route.query.wave_picking_summary_id &&
        typeof this.form.wave_picking_summary_id === "undefined"
      ) {
        this.form.wave_picking_summary_id =
          this.$route.query.wave_picking_summary_id;
      }
      if (this.$route.query.type && typeof this.form.type === "undefined") {
        this.type = parseFloat(this.$route.query.type);
        this.form.type = this.type;
      }
      if (this.$route.query.is_remark) {
        this.form.note_without_num = parseFloat(this.$route.query.is_remark);
      }
      this.form.multipleSelection = [];
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = this.resData.origin;
          // this.splitData(this.resData);
        }
      });

      this.$http
        .post("/erp/WavePicking/getWavePickingCondition", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.conditionData = res.data.data;
            this.$message.e(res.data.msg);
          } else {
            this.conditionData = res.data.data;
          }
        });
    },
    splitData(val) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const key in val.data) {
        this.resData.data[key].order_sn = val.data[key].order_sn.split("\r\n");
        this.resData.data[key].custom_note =
          val.data[key].custom_note.split("\r\n");
        this.resData.data[key].admin_note =
          val.data[key].admin_note.split("\r\n");
      }
    },
    getCity(value) {
      this.$http
        .post("/erp/WavePicking/getCity", { province: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.cityData = res.data.data;
          }
        });
    },
    getDistrict(value) {
      this.$http
        .post("/erp/WavePicking/getDistrict", { city: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.districtData = res.data.data;
          }
        });
    },
    importFileWeight(res) {
      this.fileList = []; // 删除下方文件名
      if (res.code !== 200) {
        this.$message.e(res.msg);
      } else {
        this.dialogFormVisible = false;
        this.$message.success(res.msg);
        this.form.fileList = [];
        this.fetchData();
      }
    },
    importFileExpress(res) {
      if (res.code !== 200) {
        this.$message.e(res.msg);
      } else {
        this.form.fileList = res.data;
      }
    },
    importExpress() {
      this.form.origin = this.origin;
      this.loading = true;
      this.$http
        .post("/erp/WavePicking/importExpress", this.filteredForm)
        .then((res) => {
          this.loading = false;
          this.dialogFormVisible = false;
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.$message({
              type: "success",
              message: res.data.data,
            });
            this.fileList = [];
            this.form.fileList = [];
            this.form.express = null;
            this.fetchData();
          }
        });
    },

    importFileExpress100(res) {
      if (res.code !== 200) {
        this.$message.e(res.msg);
      } else {
        this.formExpress100Task.file_list = res.data;
      }
    },
    importExpress100Task() {
      this.loading = true;
      this.$http
        .post(
          "/erp/WavePickingShipping/setShippingCompany100Task",
          this.formExpress100Task
        )
        .then((res) => {
          this.loading = false;
          this.express100FormVisible = false;
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.formExpress100Task.file_list = "";
            const { file } = res.data.data;
            console.log(res);
            if (file) {
              window.open(apiBaseURL + file);
            } else {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.fetchData();
            }
          }
        });
    },
    exportExpress100Task() {
      // this.form.is_excel = 1;
      this.loading = true;
      this.$http
        .post("/erp/WavePickingShipping/getShippingCompany100TaskTemplate", {
          task_type: 2,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.data.msg);
          } else {
            this.loading = false;
            // this.form.is_excel = 0;
            console.log(res);
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },

    importFileSpot(res) {
      this.fileList = []; // 删除下方文件名
      if (res.code !== 200) {
        this.$message.e(res.msg);
      } else {
        this.$message.success("导入成功");
        this.form.fileList = [];
        const { file } = res.data;
        if (file) {
          window.open(apiBaseURL + file);
        }
      }
    },

    exportExpress() {
      // this.form.is_excel = 1;
      this.loading = true;
      this.$http
        .post("/erp/WavePicking/exportExpress", {
          ...this.filteredForm,
          is_excel: 1,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.loading = false;
            // this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
        });
    },
    mergeWavePicking() {
      this.$confirm("是否确定合并波次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/mergeWavePicking", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.$confirm(res.data.msg, "温馨提示", {
                  confirmButtonText: "知道了",
                  cancelButtonText: "I see",
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    waybillDiscard() {
      this.form.status_id = 6;
      this.$confirm("是否确定取消面单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/waybillDiscard", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 执行打印配货单
    doPrint() {
      this.form.status_id = 2;

      this.$confirm("是否确定打印配货单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/updateWavePickingStatus", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.form.multipleSelection = [];
                this.$refs.multipleTable.clearSelection();
                this.$message({
                  type: "success",
                  message: "进入打印页面!",
                });
                this.fetchData();
                let note = 0;
                if (
                  Number(this.form.note) === 0 ||
                  typeof this.form.note === "undefined"
                ) {
                  note = this.form.note_without_num;
                } else {
                  // eslint-disable-next-line prefer-destructuring
                  note = this.form.note;
                }

                const routeData = this.$router.resolve({
                  name: `wavepicking/printwavepicking/${res.data.data}/${note}/${this.origin}`,
                });
                window.open(routeData.href + routeData.route.name, "_blank");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打印",
          });
        });
    },
    printWavePicking() {
      if (this.is_summary) {
        this.$confirm("所选配货单有包含汇总单的数据，是否确定打印?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.doPrint();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消打印",
            });
          });
      } else {
        this.doPrint();
      }
    },
    // 面单前置,打印配货单
    printWayBill() {
      this.$confirm("是否确定打印面单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/WavePicking/printWayBillOfMany", this.filteredForm)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message({
                  type: "info",
                  message: res.data.msg,
                });
              } else {
                this.printDatas = res.data.data.printDatas;
                this.print_key = 0;
                this.websocketsend(
                  JSON.stringify(this.printDatas[this.print_key])
                );
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打印",
          });
        });
    },
    getOrderId(orderSn) {
      const form = {
        order_sn: orderSn,
      };
      this.$http.post("/erp/WavePicking/getOrderLink", form).then((res) => {
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          window.open(res.data.data);
        }
      });
    },
    resetCondition() {
      this.form = {
        order_create_time: this.defaultDate(),
        create_time: this.searchDate(),
        note_without_num: 0,
        cat_ids: [],
        market_id: [],
        two_type: [],
        user_search: "",
      };
    },
    fetchStatusList(cacheRm = 0) {
      this.loading = true;
      this.form2.cacheRm = cacheRm;
      this.$http
        .post("/erp/WavePicking/getWavePickingTimeRuleStatus", this.form2)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.loading = false;
            this.statusList = res.data.data;
          }
        });
    },
    outputWaveData() {
      // this.form.is_excel = 1;
      this.loading = true;
      this.form.origin = this.origin;
      this.form.log = 1;
      this.$http
        .post("/erp/StockInRecord/exportExceptionData", {
          ...this.filteredForm,
          is_excel: 1,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            // this.form.is_excel = 0;
            this.loading = false;
            this.$message.e(res.data.msg);
          } else {
            this.loading = false;
            // this.form.is_excel = 0;
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
            } else {
              window.open(apiBaseURL + res.data.data.file);
            }
          }
          this.form.log = "";
        });
    },
    // 改变时把之前search_type的数据先清空
    search_type_change() {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const k in this.search_options) {
        delete this.form[this.search_options[k].key];
      }
    },
    showImportShipping() {
      const h = this.$createElement;
      this.$msgbox({
        title: "修改快递信息",
        message: h("p", null, [
          h(
            "el-button",
            {
              attrs: {
                type: "danger",
                size: "mini",
              },
              on: {
                click: () => {
                  this.$http
                    .post("/erp/WavePicking/importWavePickingShipping", {
                      download: 1,
                    })
                    .then((res) => {
                      window.open(apiBaseURL + res.data.data.file);
                    });
                },
              },
            },
            "下载导入模板"
          ),

          h(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "mini",
              },
              on: {
                click: () => {
                  this.$refs.uploadButton.$el.click();
                },
              },
            },
            "选择导入文件"
          ),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          console.log(action);
          if (action === "confirm") {
            this.$refs.upload.submit();
          } else {
            this.fileList = [];
          }
          done();
        },
      });
    },
    importFileShipping(response) {
      if (Number(response.code) === 200) {
        this.$message.success("上传处理成功");
        this.fileList = [];
        window.open(apiBaseURL + response.data.file);
      } else {
        this.fileList = [];
        this.$message.e(response.msg);
      }
    },
    changeFields(fields) {
      this.showFields = fields;
    },
    // 保存囤货信息
    saveKeepStock() {
      const param = JSON.parse(JSON.stringify(this.keepStock.form));
      param.limit_ship_order_ids = [];
      this.keepStock.form.limit_ship_order_ids.forEach((v) => {
        param.limit_ship_order_ids.push(v.order_id);
      });
      this.$http
        .post("/erp/WavePicking/wavePickingKeppStockSave", param)
        .then((rs) => {
          if (String(rs.data.code) !== "200") {
            this.$message.e(rs.data.msg);
            return;
          }
          this.$message.success("保存成功");
          this.$set(this.keepStock, "isShow", false);
          this.$set(this.resData.data[this.keepStock.updating], "is_stock", 1);
        });
    },

    cancelKeepStock() {
      const param = JSON.parse(JSON.stringify(this.keepStock.form));
      param.limit_ship_order_ids = [];
      this.$http
        .post("/erp/WavePicking/wavePickingKeppStockCancel", param)
        .then((rs) => {
          if (String(rs.data.code) !== "200") {
            this.$message.e(rs.data.msg);
            return;
          }
          this.$message.success("取消囤货成功");
          this.$set(this.keepStock, "isShow", false);
          this.$set(this.resData.data[this.keepStock.updating], "is_stock", 2);
        });
    },

    setStock(wavePickingId, isStock, index) {
      this.$set(this.keepStock, "updating", index);
      this.$set(this.keepStock, "action", isStock);
      this.$set(this.keepStock.form, "wave_picking_id", wavePickingId);
      if (`${isStock}` === "1") {
        const inttForm = {
          kssid: 0, // 囤货id
          limit_ship_date: "",
          limit_ship_num: "",
          is_full_allot_ship: "2",
          limit_ship_order_ids: [],
          stock_remark: "",
        };

        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const k in inttForm) {
          this.$set(this.keepStock.form, k, inttForm[k]);
        }
        this.$set(this.keepStock, "isShow", true);
        return;
      }
      this.$http
        .post("/erp/WavePicking/wavePickingKeppStockGet", {
          wave_picking_id: this.keepStock.form.wave_picking_id,
        })
        // eslint-disable-next-line consistent-return
        .then((rs) => {
          if (rs.data.code !== 200) return this.$message.e(rs.data.msg);
          const { data } = rs.data;
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const k in data) {
            if (this.keepStock.form[k] !== undefined)
              this.$set(this.keepStock.form, k, data[k]);
          }
          this.$set(this.keepStock, "isShow", true);
          this.fetchData(true);
        });
    },

    // 获取订单并弹窗
    showOrderid() {
      this.$http
        .post("/erp/WavePicking/wavePickingOrderIdGet", {
          wave_picking_id: this.keepStock.form.wave_picking_id,
        })
        .then((rs) => {
          if (String(rs.data.code) !== "200") {
            this.$message.e(rs.data.msg);
            return;
          }
          this.$set(this.keepStock.order_id, "ids", rs.data.data);
          this.$set(this.keepStock.order_id, "isShow", true);
          const _includes = [];
          this.keepStock.form.limit_ship_order_ids.forEach((v) =>
            _includes.push(v.order_id)
          );
          setTimeout(() => {
            rs.data.data.forEach((v) => {
              if (_includes.includes(v.order_id))
                this.$refs.orderSelectionTable.toggleRowSelection(v);
            });
          }, 200);
        });
    },

    // 确定订单id
    orderIdComfirm() {
      this.$set(
        this.keepStock.form,
        "limit_ship_order_ids",
        JSON.parse(JSON.stringify(this.keepStock.order_id.selection))
      );
      this.$set(this.keepStock.order_id, "selection", []);
      this.$set(this.keepStock.order_id, "isShow", false);
    },

    // 取消订单勾选
    orderIdCancel() {
      this.$set(this.keepStock.order_id, "selection", []);
      this.$set(this.keepStock.order_id, "isShow", false);
    },

    // 勾选订单
    orderSelection(selted) {
      this.$set(this.keepStock.order_id, "selection", selted);
    },

    // 拦截
    // action {1: 去拦截, 2:取消拦截}
    toStop(wavePickingId, action, rowIndex) {
      // 获取拦截内容
      const wavePickingType = 1;
      if (`${action}` === "1") {
        this._doStop("", wavePickingId, action, rowIndex, wavePickingType);
        return;
      }
      this.$http
        .post("/erp/WavePicking/stopShippingGet", {
          wave_picking_id: wavePickingId,
          wave_picking_type: wavePickingType,
        })
        .then((rs) => {
          this._doStop(
            rs.data.data,
            wavePickingId,
            action,
            rowIndex,
            wavePickingType
          );
        });
    },

    _doStop(value, wavePickingId, action, index, wavePickingType) {
      const _text = `${action}` === "1" ? "拦截" : "取消拦截";
      this.$prompt("", _text, {
        inputType: "textarea",
        inputValue: value,
      })
        .then((rs) => {
          this.$http
            .post("/erp/WavePicking/stopShippingSave", {
              wave_picking_id: wavePickingId,
              desc: rs.value,
              wave_picking_type: wavePickingType,
              is_stop_shipping: action,
            })
            // eslint-disable-next-line consistent-return
            .then((res) => {
              if (String(res.data.code) !== "200") {
                this.$message.e(res.data.msg);
                return;
              }
              this.$message.success(
                `${action}` === "1" ? "拦截成功" : "已取消拦截"
              );
              this.$set(this.resData.data[index], "is_stop_shipping", action);
            });
        })
        .catch(() => {
          // |'_'|//
        });
    },

    // 导入excel修改波次信息
    exlceImprot() {
      this.$refs.excelImport.toggle();
    },

    // 恢复波次的初始收件人信息
    recoveryConsignee(isCheck) {
      const { wave_picking_id: wavePickingId } = this;
      this.$http
        .post("/erp/WavePicking/recoverWavePickingConsignee", {
          wave_picking_id: wavePickingId,
          is_check: isCheck,
        })
        // eslint-disable-next-line consistent-return
        .then((rs) => {
          if (rs.data.code !== 200) {
            return this.$confirm(rs.data.msg, "错误提醒", {
              closeOnClickModal: false,
              showCancelButton: false,
            });
          }
          if (Number(isCheck) === 1) {
            return this.$confirm(
              "收件信息是否确认恢复为原下单的收件信息",
              "恢复至下单的收件信息",
              {
                closeOnClickModal: false,
              }
            ).then(() => {
              this.recoveryConsignee(0);
            });
          }

          this.$message.success(rs.data.msg);
          this.fetchData(true);
          this.form.change_province = "";
          this.form.change_city = "";
          this.form.change_district = 0;
          this.form.change_address = "";
          this.changeAddressVisible = false;
        });
    },

    // 尾货折销模版
    handleTailOrderTempExport() {
      wavePickApi
        .exportDiscountFile()
        .then(openDownloadWindow)
        .catch(this.$noop);
    },

    handleDialogClose() {
      this.$refs.formTailOrder.resetFields();
    },

    handleFileRemove() {
      this.formTailOrder.excel = "";
    },

    handleFileSelect() {
      this.$refs.input.click();
    },
    handleFileChange(e) {
      this.formTailOrder.excel = e.target.files[0];
      this.$refs.input.value = "";
    },

    handleExceed(files, fileList) {
      this.$message.info(
        `最多上传 ${constEnum.limit} 个文件，本次选择了 ${files.length} 个文件，已有 ${fileList.length} 个文件`
      );
    },

    // 尾货折销确定
    handleConfirmTailOrder() {
      if (this.loadingSubmitTail) {
        return;
      }
      this.$refs.formTailOrder.validate((valid) => {
        if (valid) {
          this.loadingSubmitTail = true;
          wavePickApi
            .beforeImportDiscountWavePickingByDbid(this.formTailOrder)
            .then((res) => {
              const { beSendNum, fileNum } = res;
              this.$confirm(
                "",
                `波次单待发 ${beSendNum} 件，发货文件共 ${fileNum} 件`,
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              )
                .then(() => {
                  wavePickApi
                    .importDiscountWavePickingByDbid(this.formTailOrder)
                    .then((result) => {
                      if (result?.file) {
                        openDownloadWindow(result);
                      } else {
                        this.$message.success("尾货折销导入发货成功！");
                        this.isShowDialogTailOrder = false;
                      }
                    })
                    .catch(this.$noop);
                })
                .catch(this.$noop);
            })
            .catch(this.$noop)
            .finally(() => {
              this.loadingSubmitTail = false;
            });
        }
      });
    },

    // 快递弹窗关闭回调
    handleShippingDialogClose() {
      this.form = {
        ...this.form,
        express: "",
        sender_id: "",
        logistics_id: "",
        update_shipping_type: "",
      };
      this.senders = [];
    },
    // 订单导入发货
    importOrderDelivery(res) {
      this.fileList = []; // 删除下方文件名
      if (res.code !== 200) {
        this.$message.e(res.msg);
      } else {
        this.$message.success(res.data.msg);
        this.fetchData();
      }
      if (res.data.file) {
        window.open(apiBaseURL + res.data.file);
      }
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

._icon_plus {
  font-size: 28px;
  margin-top: 5px;
  margin-left: 10px;
  cursor: pointer;
}

._order_ids {
  display: inline-block;
  width: auto;
}

._order_ids_item {
  display: inline-block;
  margin: 5px;
  border: 1px solid #ccc;
  padding: 3px 5px;
  height: 25px;
  line-height: 25px;
}

._order_sn_item {
  width: 160px;
  margin: 0;
  cursor: pointer;
}

._order_sn_item_color {
  color: #67c23a;
}

.spot_order {
  color: red;
  border: 1px solid;
  border-radius: 4px;
}

.yellow {
  color: #e2eb36;
}
</style>
<style>
.el-table .stock-row {
  background: #f7fd7b;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/WavePickingList.vue